import { Container, ContainerModule } from 'inversify';
import { TYPES } from '@/Framework/config/DI/types';

export const loadModules = (
  container: Container,
  modules: ContainerModule[],
): void => {
  if (!container.isBound(TYPES.ModulesLoaded)) {
    container.load(...modules);
    container.bind(TYPES.ModulesLoaded).toConstantValue(true);
  }
};
